
module.exports = require('./lib/index');



// WEBPACK FOOTER //
// ./~/engine.io-client/index.js